import UserApi from './UserApi';

const userApi = new UserApi();

export const getUserApi = () => userApi;
